import {ROOT_URL} from 'envs/_current/config'
import _ from 'lodash'
import {articleSchema} from '../schema'
import base, {get, getLinkToDetailGenerator, getLinkToSettingGenerator, getLinkToShareGenerator, getType,} from './base'
import {CiMemoPad} from "react-icons/ci";
import React from "react";
import {PiFileText} from "react-icons/pi";
import {AiOutlineFileSearch} from "react-icons/ai";
import {IoNewspaperOutline} from "react-icons/io5";

const getId = get('idname')

const getContainerId = get('idname')

const replaceEditState = (id) => {
    window.history.replaceState(null, 'Edit Article', `article/${id}/edit`)
}

const fromSegments = (segments = [], separator = '') => {
    return _.join(segments, separator)
}

const getDefaultURL = getLinkToDetailGenerator({getId, getType})

export const ArticleContainerTypes = Object.freeze({
    DEFAULT: 'default',
    CHANNEL: 'channel',
})

export const getLinkToDetail = (item) => {
    const URL = getDefaultURL(item)
    return fromSegments(['/news', URL])
}

export const getLinkToSetting = getLinkToSettingGenerator({getId, getType})

export const getLinkToShare = getLinkToShareGenerator({
    rootUrl: ROOT_URL,
    getType,
    getId,
})

const getLinkToCreate = (item) => {
    const channel_id = getId(item)
    return channel_id ? `/article/new?channel_id=${channel_id}` : '/article/new'
}

const getEditingURL = (item) => {
    return fromSegments(
        [
            // '/news',
            '',
            getType(item),
            getId(item),
            'edit',
        ],
        '/'
    )
}

export const CDTypes = Object.freeze({
    MEMO: 'memo',
    FORM: 'form',
    ARTICLE: 'articles',
    RESEARCH: 'research',
})

// Todo: implement translation
// memo (ghi nhớ) / form (Biểu mẫu) / research (Bài nghiên cứu) / article (bài viết)
// Colors:
// 'error',
// 'warning',
// 'success',
// 'default',
// 'processing',
// 'blue',
// '#2db7f5'
// ...
export const fromCDType = (type) => {
    switch (type) {
        case CDTypes.MEMO:
            return {
                icon: <CiMemoPad className="text-green-500"/>,
                label: 'memo',
                color: 'green',
                classColor: 'text-green-600 bg-green-100 border-600',
            }
        case CDTypes.FORM:
            return {
                icon: <PiFileText className="text-orange-600"/>,
                label: 'form',
                color: 'orange',
                classColor: 'text-orange-600 bg-orange-100',
            }
        case CDTypes.RESEARCH:
            return {
                icon: <AiOutlineFileSearch className="text-indigo-600"/>,
                label: 'research',
                color: 'indigo',
                classColor: 'text-indigo-600 bg-indigo-50',
            }
        case CDTypes.ARTICLE:
        default:
            return {
                icon: <IoNewspaperOutline className="text-blue-600"/>,
                label: 'articles',
                color: 'blue',
                classColor: 'text-blue-700 bg-blue-100',
            }
    }
}

export default {
    ...base,
    getLinkToDetail,
    getLinkToCreate,
    getLinkToSetting,
    getLinkToShare,
    schema: articleSchema,
    getId,
    getContainerId,
    replaceEditState,
    getEditingURL,
}
